<template>
  <div>
    <div v-if="!userAgent">
      <!-- banner -->
      <div class="banner">
        <img :src="image" alt />
      </div>
      <!-- tabs -->
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="tabClick($event,show)">
          <el-tab-pane :label="msg.name" v-for="(msg,index) in show" :key="index">
            <div class="tabs-title">
              <div class="one" v-for="(item,index) in showw" :key="index">
                <div>{{item.title}}</div>
                <div>
                  <img :src="item.image" alt />
                </div>
                <div>{{item.simple}}</div>
                <div @click="details(item.id)">
                  <button>了解更多</button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div v-else>
      <!-- banner -->
      <div class="banner1">
        <img :src="image" alt />
      </div>
      <!-- tabs -->
      <div class="tabs1">
        <el-tabs v-model="activeName" @tab-click="tabClick($event,show)">
          <el-tab-pane :label="msg.name" v-for="(msg,index) in show" :key="index">
            <div class="tabs-title1">
              <div class="one1" v-for="(item,index) in showw" :key="index">
                <div>{{item.title}}</div>
                <div>
                  <img :src="item.image" alt />
                </div>
                <div>{{item.simple}}</div>
                <div @click="details(item.id)">
                  <button>了解更多</button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      activeName: "0",
      image: "",
      show: [],
      showw: [],
      show1: [],
      showIndex: [],
      showDetails: [],
      id:''
    };
  },
  methods: {
    // 厂能源管控平台详情
    details(id) {
      this.$router.push(`/details?id=${id}`);
    },
    tabClick: function (tab) {
      var that = this;
      let url = "/show?c=" + tab.name;
      this.$root.newVue.$emit("nav_index", url);
      // this.$router.push(url);
      let key = tab.index;
      let id = this.show[key].id;
      that.$http.get(`cases/l_req?id=${id}`).then(function (res) {
        that.showw = res.data.data;
      });
    },
  },
  watch: {
    $route: {
      handler() {
        console.log(this.$route.query.c);
        this.activeName = this.$route.query.c;
      },
      deep: true,
    },
  },
  mounted() {
    var that = this;
    //  let id = that.$route.query.id;
    that.activeName = this.$route.query.c;
    that.$http.get("images/cases").then(function (res) {
      //轮播
      that.image = res.data.data.image;
    });
    that.$http.get("cases/index").then(function (res) {
      that.show = res.data.data;
      let id = that.show[that.$route.query.c].id;
      that.$http.get(`cases/l_req?id=${id}`).then(function (res) {
        that.showw = res.data.data;
      });
    });
  },
};
</script>
<style scoped lang="scss">
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.tabs {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  .tabs-title {
    display: grid;
    width: 100%;
    margin-right: 2%;
    padding-bottom: 3rem;
    justify-content: space-between;
    grid-template-columns:repeat(3,31%) ;
    .one {
      background: #fff;
      padding-left: 1rem;
      margin-top: 3rem;
      cursor: pointer;
      width: 100%;
      div {
        padding-top: 4%;
      }
    }
    .one div:first-child {
      color: #43ae82;
      font-size: 20px;
      font-weight: bold;
    }
    div:nth-child(2) img {
      width: 95%;
    }
    .one div:nth-child(3) {
      width: 96%;
      text-align: justify;
      font-size: 14px;
      color: #333;
      line-height: 1.5rem;
    }
    .one div:nth-child(4) {
      padding-bottom: 6%;
      button {
        color: #43ae82;
        border: 1px solid #43ae82;
        background: #fff;
        border-radius: 4px;
        font-size: 14px;
        width: 95px;
        height: 35px;
      }
    }
    .one:hover {
      background: #43ae82;
      cursor: pointer;
      div:first-child {
        color: #fff;
      }
      div:nth-child(3) {
        color: #fff;
      }
      div:nth-child(4) button {
        border: 1px solid #fff;
        color: #fff;
        background: #43ae82;
      }
    }
  }
}
button {
  outline: none;
}
.banner1 {
  width: 100%;
  img {
    width: 100%;
    height: 7rem;
  }
}
.tabs1 {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  .tabs-title1 {
    margin-top: 5%;
    margin-right: 2%;
    padding-bottom: 2rem;
    .one1 {
      background: #fff;
      padding-left: 1rem;
      margin-top: 1.2rem;
      div {
        padding-top: 4%;
      }
      .btn {
        height: 30px !important;
        font-size: 11px !important;
        width: 80px !important;
      }
    }
    .one1 div:first-child {
      color: #43ae82;
      font-size: 0.9rem;
      font-weight: bold;
    }
    div:nth-child(2) img {
      width: 95%;
    }
    .one1 div:nth-child(3) {
      width: 96%;
      text-align: justify;
      font-size: 14px;
      color: #333;
      line-height: 1.5rem;
    }
    .one1 div:nth-child(4) {
      padding-bottom: 6%;
      button {
        color: #43ae82;
        border: 1px solid #43ae82;
        background: #fff;
        border-radius: 4px;
        font-size: 14px;
        width: 95px;
        height: 35px;
      }
    }
    .one:hover {
      background: #43ae82;
      cursor: pointer;
      div:first-child {
        color: #fff;
      }
      div:nth-child(3) {
        color: #fff;
      }
      div:nth-child(4) button {
        border: 1px solid #fff;
        color: #fff;
        background: #43ae82;
      }
    }
  }
}
</style>
<style>
.tabs .el-tabs__item {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}
.tabs .el-tabs__content {
  overflow: hidden;
  position: relative;
  top: 0;
  bottom: 0;
  margin-top: -1%;
  padding-bottom: 3rem;
  width: 100%;
  margin: 0 auto;
}
.tabs .tabs-title .title {
  margin: 0 auto;
  padding-top: 4rem;
}
.tabs .el-tabs__item:hover {
  color: #43ae82;
  cursor: pointer;
}
.tabs .el-tabs__nav-scroll,
.tabs .el-tab-pane {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.el-tabs__header {
  width: 100% !important;
}

.tabs1 .el-tabs__nav-scroll {
  padding-bottom: 6px;
  height: 3rem;
  line-height: 3rem;
}
.tabs1 .el-tabs__nav-next {
  right: 0;
  margin-top: 2.5%;
}
.tabs1 .el-tabs__nav-prev {
  left: 0;
  margin-top: 2.5%;
}
.tabs1 .el-tabs__item {
  font-size: 14px !important;
  font-weight: bold !important;
}
.tabs1 .el-tabs__nav-scroll,
.tabs1 .el-tab-pane {
  width: 90% !important;
  margin: 0 auto;
}
.tabs1 .el-tabs__content {
  padding-bottom: 0 !important;
}
</style>